export enum ScoreStatus {
  exceed = "exceed",
  pass = "pass",
  warn = "warn",
  fail = "fail"
}

export interface PasswordScore {
  calculatedScore: number
  numOfMidChar: number
  noOfSymBonus: number
  lcImgStatus: ScoreStatus
  ucImgStatus: ScoreStatus
  numImgStatus: ScoreStatus
  symImgStatus: ScoreStatus
  midImgStatus: ScoreStatus
  reqImgStatus: ScoreStatus
  pwdLenImgStatus: ScoreStatus
  pwdLength: number
  noOfLC: number
  noOfUC: number
  noOfNum: number
  noOfSym: number
  numOfRequirements: number
  noOfCharBonus: number
  noOfLCBonus: number
  noOfUCBonus: number
  noOfNumBonus: number
  noOfMidBonus: number
  noOfRequirementsBonus: number
  noOfAlphasOnly: number
  noOfNumbersOnly: number
  noOfRepChar: number
  noOfConsecAlphaUC: number
  noOfConsecAlphaLC: number
  noOfConsecNumber: number
  noOfSeqAlpha: number
  noOfSeqNumber: number
  noOfSeqSymbol: number
  alphasOnlyImgStatus: ScoreStatus
  numbersOnlyImgStatus: ScoreStatus
  repCharImgStatus: ScoreStatus
  consecAlphaUCImgStatus: ScoreStatus
  consecAlphaLCImgStatus: ScoreStatus
  consecNumberImgStatus: ScoreStatus
  seqAlphaImgStatus: ScoreStatus
  seqNumberImgStatus: ScoreStatus
  seqSymbolImgStatus: ScoreStatus
  noOfAlphasOnlyBonus: number
  noOfNumbersOnlyBonus: number
  noOfRepCharBonus: number
  noOfConsecAlphaUCBonus: number
  noOfConsecAlphaLCBonus: number
  noOfConsecNumberBonus: number
  noOfSeqAlphaBonus: number
  noOfSeqNumberBonus: number
  noOfSeqSymbolBonus: number
  nConsecSymbol: number
  nConsecCharType: number
  nSeqChar: number
}

export default function CalculatePasswordScore(pwd: string): PasswordScore {
  const result: PasswordScore = {
    calculatedScore: 0,
    numOfMidChar: 0,
    noOfSymBonus: 0,
    lcImgStatus: ScoreStatus.fail,
    ucImgStatus: ScoreStatus.fail,
    numImgStatus: ScoreStatus.fail,
    symImgStatus: ScoreStatus.fail,
    midImgStatus: ScoreStatus.fail,
    reqImgStatus: ScoreStatus.fail,
    pwdLenImgStatus: ScoreStatus.fail,
    pwdLength: 0,
    noOfLC: 0,
    noOfUC: 0,
    noOfNum: 0,
    noOfSym: 0,
    numOfRequirements: 0,
    noOfCharBonus: 0,
    noOfLCBonus: 0,
    noOfUCBonus: 0,
    noOfNumBonus: 0,
    noOfMidBonus: 0,
    noOfRequirementsBonus: 0,
    noOfAlphasOnly: 0,
    noOfNumbersOnly: 0,
    noOfRepChar: 0,
    noOfConsecAlphaUC: 0,
    noOfConsecAlphaLC: 0,
    noOfConsecNumber: 0,
    noOfSeqAlpha: 0,
    noOfSeqNumber: 0,
    noOfSeqSymbol: 0,
    alphasOnlyImgStatus: ScoreStatus.pass,
    numbersOnlyImgStatus: ScoreStatus.pass,
    repCharImgStatus: ScoreStatus.pass,
    consecAlphaUCImgStatus: ScoreStatus.pass,
    consecAlphaLCImgStatus: ScoreStatus.pass,
    consecNumberImgStatus: ScoreStatus.pass,
    seqAlphaImgStatus: ScoreStatus.pass,
    seqNumberImgStatus: ScoreStatus.pass,
    seqSymbolImgStatus: ScoreStatus.pass,
    noOfAlphasOnlyBonus: 0,
    noOfNumbersOnlyBonus: 0,
    noOfRepCharBonus: 0,
    noOfConsecAlphaUCBonus: 0,
    noOfConsecAlphaLCBonus: 0,
    noOfConsecNumberBonus: 0,
    noOfSeqAlphaBonus: 0,
    noOfSeqNumberBonus: 0,
    noOfSeqSymbolBonus: 0,
    nConsecSymbol: 0,
    nConsecCharType: 0,
    nSeqChar: 0
  }
  const reverse = (str: string): string => str.split("").reverse().join("")
  let nScore: number = 0, nAlphaUC: number = 0, nAlphaLC: number = 0, nNumber: number = 0, nSymbol: number = 0,
    nMidChar: number = 0, nRequirements: number = 0, nAlphasOnly: number = 0, nNumbersOnly: number = 0, nUnqChar: number = 0,
    nRepChar: number = 0, nRepInc: number = 0, nConsecAlphaUC: number = 0, nConsecAlphaLC: number = 0, nConsecNumber: number = 0,
    nConsecSymbol: number = 0, nConsecCharType: number = 0, nSeqAlpha: number = 0, nSeqNumber: number = 0, nSeqSymbol: number = 0,
    nSeqChar: number = 0, nReqChar: number = 0
  let nMultMidChar: number = 2, nMultConsecAlphaUC: number = 2, nMultConsecAlphaLC: number = 2,
    nMultConsecNumber: number = 2
  let nMultSeqAlpha: number = 3, nMultSeqNumber: number = 3, nMultSeqSymbol: number = 3
  let nMultLength: number = 4, nMultNumber: number = 4
  let nMultSymbol: number = 6
  let nTmpAlphaUC: string = "", nTmpAlphaLC: string = "", nTmpNumber: string = "",
    nTmpSymbol: string = ""
  let sAlphaUC: string = "0", sAlphaLC: string = "0", sNumber: string = "0",
    sSymbol: string = "0", sMidChar: string = "0", sRequirements: string = "0",
    sAlphasOnly: string = "0", sNumbersOnly: string = "0", sRepChar: string = "0",
    sConsecAlphaUC: string = "0", sConsecAlphaLC: string = "0",
    sConsecNumber: string = "0", sSeqAlpha: string = "0",
    sSeqNumber: string = "0", sSeqSymbol: string = "0"
  let sAlphas: string = "abcdefghijklmnopqrstuvwxyz"
  let sNumerics: string = "01234567890"
  let sSymbols: string = ")!@#$%^&*()"
  let nMinPwdLen = 8
  if (pwd) {
    nScore = parseInt(String(pwd.length * nMultLength), 10)
    result.pwdLength = pwd.length
    let arrPwd = pwd.replace(/\s+/g, "").split(/\s*/)
    let arrPwdLen = arrPwd.length

    /* Loop through password to check for Symbol, Numeric, Lowercase and Uppercase
     pattern matches
     */
    for (let charValue = 0; charValue < arrPwdLen; charValue++) {
      if (arrPwd[charValue].match(/[A-Z]/g)) {
        if (nTmpAlphaUC !== "") {
          if ((parseInt(nTmpAlphaUC) + 1) === charValue) {
            nConsecAlphaUC++
            nConsecCharType++
          }
        }
        nTmpAlphaUC = String(charValue)
        nAlphaUC++
      }
      else if (arrPwd[charValue].match(/[a-z]/g)) {
        if (nTmpAlphaLC !== "") {
          if ((parseInt(nTmpAlphaLC) + 1) === charValue) {
            nConsecAlphaLC++
            nConsecCharType++
          }
        }
        nTmpAlphaLC = String(charValue)
        nAlphaLC++
      }
      else if (arrPwd[charValue].match(/[0-9]/g)) {
        if (charValue > 0 && charValue < (arrPwdLen - 1)) {
          nMidChar++
        }
        if (nTmpNumber !== "") {
          if ((parseInt(nTmpNumber) + 1) === charValue) {
            nConsecNumber++
            nConsecCharType++
          }
        }
        nTmpNumber = String(charValue)
        nNumber++
      }
      else if (arrPwd[charValue].match(/[^a-zA-Z0-9_]/g)) {
        if (charValue > 0 && charValue < (arrPwdLen - 1)) {
          nMidChar++
        }
        if (nTmpSymbol !== "") {
          if ((parseInt(nTmpSymbol) + 1) === charValue) {
            nConsecSymbol++
            nConsecCharType++
          }
        }
        nTmpSymbol = String(charValue)
        nSymbol++
      }
      /* Internal loop through password to check for repeat characters */
      let bCharExists = false
      for (let repeatedChar = 0; repeatedChar < arrPwdLen; repeatedChar++) {
        if (arrPwd[charValue] === arrPwd[repeatedChar] && charValue !== repeatedChar) { /* repeat character exists */
          bCharExists = true
          /*
           Calculate increment deduction based on proximity to identical characters
           Deduction is incremented each time a new match is discovered
           Deduction amount is based on total password length divided by the
           difference of distance between currently selected match
           */
          nRepInc += Math.abs(arrPwdLen / (repeatedChar - charValue))
        }
      }
      if (bCharExists) {
        nRepChar++
        nUnqChar = arrPwdLen - nRepChar
        nRepInc = (nUnqChar) ? Math.ceil(nRepInc / nUnqChar) : Math.ceil(nRepInc)
      }
    }
    /* Check for sequential alpha string patterns (forward and reverse) */
    for (let sequentialAlpha = 0; sequentialAlpha < 23; sequentialAlpha++) {
      let sFwd = sAlphas.substring(sequentialAlpha, parseInt(String(sequentialAlpha + 3), 10))
      let sRev = reverse(sFwd)
      if (pwd.toLowerCase().indexOf(sFwd) !== -1 ||
        pwd.toLowerCase().indexOf(sRev) !== -1) {
        nSeqAlpha++
        nSeqChar++
      }
    }

    /* Check for sequential numeric string patterns (forward and reverse) */
    for (let sequentialNumeric = 0; sequentialNumeric < 8; sequentialNumeric++) {
      let sFwd = sNumerics.substring(sequentialNumeric, parseInt(String(sequentialNumeric + 3), 10))
      let sRev = reverse(sFwd)
      if (pwd.toLowerCase().indexOf(sFwd) !== -1 ||
        pwd.toLowerCase().indexOf(sRev) !== -1) {
        nSeqNumber++
        nSeqChar++
      }
    }

    /* Check for sequential symbol string patterns (forward and reverse) */
    for (let sequentialSymbol = 0; sequentialSymbol < 8; sequentialSymbol++) {
      let sFwd = sSymbols.substring(sequentialSymbol, parseInt(String(sequentialSymbol + 3), 10))
      let sRev = reverse(sFwd)
      if (pwd.toLowerCase().indexOf(sFwd) !== -1 ||
        pwd.toLowerCase().indexOf(sRev) !== -1) {
        nSeqSymbol++
        nSeqChar++
      }
    }

    /* Modify overall score value based on usage vs requirements */

    /* General point assignment */
    result.noOfCharBonus = nScore
    if (nAlphaUC > 0 && nAlphaUC < result.pwdLength) {
      nScore = parseInt(String(nScore + ((result.pwdLength - nAlphaUC) * 2)), 10)
      sAlphaUC = String((result.pwdLength - nAlphaUC) * 2)
    }
    if (nAlphaLC > 0 && nAlphaLC < result.pwdLength) {
      nScore = parseInt(String(nScore + ((result.pwdLength - nAlphaLC) * 2)), 10)
      sAlphaLC = String((result.pwdLength - nAlphaLC) * 2)
    }
    if (nNumber > 0 && nNumber < result.pwdLength) {
      nScore = parseInt(String(nScore + (nNumber * nMultNumber)), 10)
      sNumber = String(nNumber * nMultNumber)
    }
    if (nSymbol > 0) {
      nScore = parseInt(String(nScore + (nSymbol * nMultSymbol)), 10)
      sSymbol = String(nSymbol * nMultSymbol)
    }
    if (nMidChar > 0) {
      nScore = parseInt(String(nScore + (nMidChar * nMultMidChar)), 10)
      sMidChar = String(nMidChar * nMultMidChar)
    }

    result.noOfUCBonus = parseInt(sAlphaUC)
    result.noOfLCBonus = parseInt(sAlphaLC)
    result.noOfNumBonus = parseInt(sNumber)
    result.noOfSymBonus = parseInt(sSymbol)
    result.noOfMidBonus = parseInt(sMidChar)

    /* Point deductions for poor practices */
    if ((nAlphaLC > 0 || nAlphaUC > 0) && nSymbol === 0 && nNumber === 0) {  // Only Letters
      nScore = parseInt(String(nScore - result.pwdLength), 10)
      nAlphasOnly = result.pwdLength
      sAlphasOnly = String(result.pwdLength)
    }
    if (nAlphaLC === 0 && nAlphaUC === 0 && nSymbol === 0 && nNumber > 0) {  // Only Numbers
      nScore = parseInt(String(nScore - result.pwdLength), 10)
      nNumbersOnly = result.pwdLength
      sNumbersOnly = String(result.pwdLength)
    }
    if (nRepChar > 0) {  // Same character exists more than once
      nScore = parseInt(String(nScore - nRepInc), 10)
      sRepChar = String(nRepInc)
    }
    if (nConsecAlphaUC > 0) {  // Consecutive Uppercase Letters exist
      nScore = parseInt(String(nScore - (nConsecAlphaUC * nMultConsecAlphaUC)), 10)
      sConsecAlphaUC = String(nConsecAlphaUC * nMultConsecAlphaUC)
    }
    if (nConsecAlphaLC > 0) {  // Consecutive Lowercase Letters exist
      nScore = parseInt(String(nScore - (nConsecAlphaLC * nMultConsecAlphaLC)), 10)
      sConsecAlphaLC = String(nConsecAlphaLC * nMultConsecAlphaLC)
    }
    if (nConsecNumber > 0) {  // Consecutive Numbers exist
      nScore = parseInt(String(nScore - (nConsecNumber * nMultConsecNumber)), 10)
      sConsecNumber = String(nConsecNumber * nMultConsecNumber)
    }
    if (nSeqAlpha > 0) {  // Sequential alpha strings exist (3 characters or more)
      nScore = parseInt(String(nScore - (nSeqAlpha * nMultSeqAlpha)), 10)
      sSeqAlpha = String(nSeqAlpha * nMultSeqAlpha)
    }
    if (nSeqNumber > 0) {  // Sequential numeric strings exist (3 characters or more)
      nScore = parseInt(String(nScore - (nSeqNumber * nMultSeqNumber)), 10)
      sSeqNumber = String(nSeqNumber * nMultSeqNumber)
    }
    if (nSeqSymbol > 0) {  // Sequential symbol strings exist (3 characters or more)
      nScore = parseInt(String(nScore - (nSeqSymbol * nMultSeqSymbol)), 10)
      sSeqSymbol = String(nSeqSymbol * nMultSeqSymbol)
    }
    result.noOfAlphasOnlyBonus = parseInt(sAlphasOnly)
    result.noOfNumbersOnlyBonus = parseInt(sNumbersOnly)
    result.noOfRepCharBonus = parseInt(sRepChar)
    result.noOfConsecAlphaUCBonus = parseInt(sConsecAlphaUC)
    result.noOfConsecAlphaLCBonus = parseInt(sConsecAlphaLC)
    result.noOfConsecNumberBonus = parseInt(sConsecNumber)
    result.noOfSeqAlphaBonus = parseInt(sSeqAlpha)
    result.noOfSeqNumberBonus = parseInt(sSeqNumber)
    result.noOfSeqSymbolBonus = parseInt(sSeqSymbol)


    /* Determine if mandatory requirements have been met and set image indicators
     accordingly */
    result.noOfUC = nAlphaUC
    result.noOfLC = nAlphaLC
    result.noOfNum = nNumber
    result.noOfSym = nSymbol

    if (result.pwdLength === 8) {
      result.pwdLenImgStatus = ScoreStatus.pass
      nReqChar++
    }
    else if (result.pwdLength > 8) {
      result.pwdLenImgStatus = ScoreStatus.exceed
      nReqChar++
    }
    else {
      result.pwdLenImgStatus = ScoreStatus.fail
    }

    if (result.noOfUC === 1) {
      result.ucImgStatus = ScoreStatus.pass
      nReqChar++
    }
    else if (result.noOfUC > 1) {
      result.ucImgStatus = ScoreStatus.exceed
      nReqChar++
    }
    else {
      result.ucImgStatus = ScoreStatus.fail
    }

    if (result.noOfLC === 1) {
      result.lcImgStatus = ScoreStatus.pass
      nReqChar++
    }
    else if (result.noOfLC > 1) {
      result.lcImgStatus = ScoreStatus.exceed
      nReqChar++
    }
    else {
      result.lcImgStatus = ScoreStatus.fail
    }

    if (result.noOfNum === 1) {
      result.numImgStatus = ScoreStatus.pass
      nReqChar++
    }
    else if (result.noOfNum > 1) {
      result.numImgStatus = ScoreStatus.exceed
      nReqChar++
    }
    else {
      result.numImgStatus = ScoreStatus.fail
    }

    if (result.noOfSym === 1) {
      result.symImgStatus = ScoreStatus.pass
      nReqChar++
    }
    else if (result.noOfSym > 1) {
      result.symImgStatus = ScoreStatus.exceed
      nReqChar++
    }
    else {
      result.symImgStatus = ScoreStatus.fail
    }

    nRequirements = nReqChar
    let nMinReqChars = 0
    if (pwd.length >= nMinPwdLen) {
      nMinReqChars = 3
    } else {
      nMinReqChars = 4
    }
    if (nRequirements > nMinReqChars) {  // One or more required characters exist
      nScore = parseInt(String(nScore + (nRequirements * 2)), 10)
      sRequirements = String(nRequirements * 2)
    }
    result.noOfRequirementsBonus = parseInt(sRequirements)

    /* Determine if additional bonuses need to be applied and set image
     indicators accordingly */

    result.numOfMidChar = nMidChar
    result.numOfRequirements = nRequirements

    if (result.numOfMidChar === 1) {
      result.midImgStatus = ScoreStatus.pass
    }
    else if (result.numOfMidChar > 1) {
      result.midImgStatus = ScoreStatus.exceed
    }
    else {
      result.midImgStatus = ScoreStatus.fail
    }

    if (result.numOfRequirements === nMinReqChars + 1) {
      result.reqImgStatus = ScoreStatus.pass
    }
    else if (result.numOfRequirements > nMinReqChars + 1) {
      result.reqImgStatus = ScoreStatus.exceed
    }
    else {
      result.reqImgStatus = ScoreStatus.fail
    }

    /* Determine if suggested requirements have been met and set image indicators
     accordingly */
    result.noOfAlphasOnly = nAlphasOnly
    result.noOfNumbersOnly = nNumbersOnly
    result.noOfRepChar = nRepChar
    result.noOfConsecAlphaUC = nConsecAlphaUC
    result.noOfConsecAlphaLC = nConsecAlphaLC
    result.noOfConsecNumber = nConsecNumber
    result.noOfSeqAlpha = nSeqAlpha
    result.noOfSeqNumber = nSeqNumber
    result.noOfSeqSymbol = nSeqSymbol
    result.nConsecSymbol = nConsecSymbol
    result.nConsecCharType = nConsecCharType
    result.nSeqChar = nSeqChar

    if (result.noOfAlphasOnly > 0) {
      result.alphasOnlyImgStatus = ScoreStatus.warn
    }
    else {
      result.alphasOnlyImgStatus = ScoreStatus.pass
    }

    if (result.noOfNumbersOnly > 0) {
      result.numbersOnlyImgStatus = ScoreStatus.warn
    }
    else {
      result.numbersOnlyImgStatus = ScoreStatus.pass
    }

    if (result.noOfRepChar > 0) {
      result.repCharImgStatus = ScoreStatus.warn
    }
    else {
      result.repCharImgStatus = ScoreStatus.pass
    }

    if (result.noOfConsecAlphaUC > 0) {
      result.consecAlphaUCImgStatus = ScoreStatus.warn
    }
    else {
      result.consecAlphaUCImgStatus = ScoreStatus.pass
    }

    if (result.noOfConsecAlphaLC > 0) {
      result.consecAlphaLCImgStatus = ScoreStatus.warn
    }
    else {
      result.consecAlphaLCImgStatus = ScoreStatus.pass
    }

    if (result.noOfConsecNumber > 0) {
      result.consecNumberImgStatus = ScoreStatus.warn
    }
    else {
      result.consecNumberImgStatus = ScoreStatus.pass
    }

    if (result.noOfSeqAlpha > 0) {
      result.seqAlphaImgStatus = ScoreStatus.warn
    }
    else {
      result.seqAlphaImgStatus = ScoreStatus.pass
    }

    if (result.noOfSeqNumber > 0) {
      result.seqNumberImgStatus = ScoreStatus.warn
    }
    else {
      result.seqNumberImgStatus = ScoreStatus.pass
    }

    if (result.noOfSeqSymbol > 0) {
      result.seqSymbolImgStatus = ScoreStatus.warn
    }
    else {
      result.seqSymbolImgStatus = ScoreStatus.pass
    }
    result.calculatedScore = nScore
  }

  return result
}
